// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from './queries'
import { ModelsResponse } from '../../types/api-types'
import { RawConfig } from '../store/slice/configSlice'
import { store } from '../store/store'
import { setHasMultisize } from '../store/slice/settingsSlice'

// API used for the Model ressource
export const apiModel = createApi({
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getModels: builder.query<ModelsResponse, RawConfig | null>({
            providesTags: ['Model'],
            query: (input) => {
                const storeConfig = store.getState().config.config
                let fullUrl = '/models'
                if (storeConfig && storeConfig['api_prefix']) {
                    fullUrl =
                        (!storeConfig['api_prefix'].match(/^\//) ? '/' : '') +
                        storeConfig['api_prefix'] +
                        '/models'
                }

                return {
                    url: fullUrl,
                    params: input || undefined,
                }
            },
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    // `onStart` side-effect
                    const { data: queryData } = await queryFulfilled

                    // `onSuccess` side-effect
                    // ---- Check if we have multisize data and update the store value ----
                    dispatch(
                        setHasMultisize(!!queryData.items.find((model) => model.look_multisizes))
                    )
                } catch {
                    // `onError` side-effect
                }
            },
        }),
    }),
    reducerPath: 'apiModel',
    tagTypes: ['Model'],
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetModelsQuery } = apiModel

// Invalidate Action to refresh the Model object
export const invalidateGetModelsAction = {
    payload: ['Model'],
    type: 'apiModel/invalidateTags',
}
